import React from 'react';

export default React.createContext({
    onChange() {
        throw new Error('Context not ready');
    },
    updateValidation() {
        throw new Error('Context not ready');
    },
    hasError() {
        throw new Error('Context not ready');
    },
    getValue() {
        throw new Error('Context not ready');
    },
    removeValue() {
        throw new Error('Context not ready');
    },
    touched() {
        throw new Error('Context not ready');
    },
    remove() {
        throw new Error('Context not ready');
    },
    getHasSubmitted() {
        throw new Error('Context not ready');
    },
    getRolle() {
        throw new Error('Context not ready');
    },
});
